import { useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Menu, MenuItem, Sidebar, SubMenu } from 'react-pro-sidebar';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import Assets from '../../assets/images/assests.png';
import Calender from '../../assets/images/calender.png';
import Contract from '../../assets/images/contract.png';
import Dashboard from '../../assets/images/dashboard.png';
import HospitalMaster from '../../assets/images/hospital_master.png';
import InventoryStock from '../../assets/images/inventory-stock.png';
// import Logo from '../../assets/images/logo_mini.svg';
import Logo from '../../assets/images/NewLogo.svg';
import Maintenance from '../../assets/images/maintenance.png';
import Report from '../../assets/images/report.png';
import Staff from '../../assets/images/staff.png';
import Vendor from '../../assets/images/vendor.png';
import Option from '../../assets/images/option.png';
import {
    hospitalMasters,
    maintenance,
    assets,
    staff,
    inventory,
    vendor,
    contract,
    reports,
    options,
    calendar
} from '../../utility/constants/sidebar';
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import { useAccess } from "../../AccessContext";

function SideBar() {
    const theme = useTheme();
    const { moduleAccess, screenAccess } = useAccess();

    const [open, setOpen] = useState(undefined);
    const [open2, setOpen2] = useState(undefined);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [hasAccess, setHasAccess] = useState(moduleAccess)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const selectedIndex = useSelector((state) => state.authendicationReducer.selectedIndex);
    const roleName = localStorage.getItem('roleName');
    const moduleName = localStorage.getItem('module');

    useEffect(() => {
        setHasAccess(moduleAccess)
    }, [moduleAccess])

  //  console.log(moduleAccess,screenAccess,"==<moduleAccess");
    
    const handleMouseEnter = () => {
        setIsCollapsed(false);
    }
    const handleMouseLeave = () => {
        setIsCollapsed(true);
    }
    const handleSubmenuClick = (label) => {
        if (open === label) {
            setOpen(undefined)
        } else {
            setOpen(label)
        }

    }
    const handleSubmenu2Click = (label) => {
        if (open2 === label) {
            setOpen2(undefined)
        } else {
            setOpen2(label)
        }

    }
    const handleNavigation = (path) => {
        navigate(path);
    };
    const handleMenuItemClick = (path, label, submenu) => {
        if (path !== '#') {
            handleNavigation(path)
            dispatch(setSelectedIndex('SET_INDEX_LABEL', label));
            dispatch(setHeaderName('SET_HEADER_NAME', submenu));
        }
    }
  //  console.log(hasAccess,"hasAccess");
    
    return (

        <Sidebar
            className='sidebar'
            collapsed={isCollapsed}
            rootStyles={{
                minHeight: '100vh',
                backgroundColor: theme.palette.primary.main,     //Need to change for dark mode
                border: 'none',
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 1600,

                fontSize: 12,
                '& .ps-sidebar-container': {
                    backgroundColor: 'inherit'
                }
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Link to='#' style={{ display: 'block', textAlign: 'start', padding: '30px 10px', }}><img src={Logo} alt='Logo' /></Link>
            <Menu
                menuItemStyles={{
                    button: ({ level, active, disabled }) => {
                        // only apply styles on first level elements of the tree
                        if (level === 0)
                            return {
                                color: disabled ? '#f5d9ff' : '#FFF',
                            };
                    },
                }}
                rootStyles={{
                    backgroundColor: theme.palette.primary.main,    //Need to change for dark mode
                    height: 'calc(100vh - 114px)',
                    overflow: 'auto',
                    color: '#3B3B3B',
                    '& .ps-menu-button': {
                        height: '36px',
                        '&:not(.ps-disabled,.ps-open):hover': {
                            background: theme.palette.primary.light,
                        },
                        '&.ps-disabled': {
                            backgroundColor: '#9377b4'
                        },
                        '&.ps-open': {
                            backgroundColor: !isCollapsed ? theme.palette.primary.dark : 'transparent'
                        },
                        '& .ps-submenu-expand-icon': {
                            // display: 'none'
                            '& span': {
                                display: isCollapsed ? 'none' : ''
                            }
                        },
                        '& .ps-menu-icon.ps-active:not(.ps-open)': {
                            // backgroundColor: 'rgba(190, 142, 228, 1)'
                            background: theme.palette.primary.light,
                            borderRadius: '4px'
                        },
                        '&.ps-active:not(:hover)': {
                            backgroundColor: theme.palette.primary.light,
                            color: theme.palette.common.white,
                        }
                    },
                    // submenu styles
                    '& .ps-submenu-root .ps-submenu-content': {
                        backgroundColor: '#f8f3fb',
                        '& .ps-menu-button': {
                            height: '36px',
                            '&:not(.ps-disabled,.ps-open):hover': {
                                // backgroundColor: '#e2bdff36',
                                // backgroundColor: '#E1D4EC',
                                backgroundColor: theme.palette.primary.hover,
                                // color: theme.palette.primary.contrastText,
                            },
                            '&.ps-open': {
                                color: theme.palette.common.white
                            },
                            '&.ps-active:hover': {
                                color: theme.palette.common.white,
                                backgroundColor: theme.palette.primary.light,
                            }
                        }
                    }
                }}
            >
                {/* actual menu starts from here  */}

                {/* {moduleName === 'f2934d87-5a52-4ed1-b39c-ae2b1fa8ce39' && roleName === 'CorporateAdmin'  && <MenuItem icon={<img src={Dashboard} alt='PowerBI Dashboard' />} onClick={() => handleMenuItemClick('/overalldashboard', 'Overall Dashboard', 'Overall Dashboard')}>Overall Dashboard</MenuItem>}  */}
                {hasAccess.powerBIdashboard && 
                    <MenuItem icon={<img src={Dashboard} alt='PowerBI Dashboard' />} onClick={() => handleMenuItemClick('/overalldashboard', 'Overall Dashboard', 'Overall Dashboard')}>Overall Dashboard</MenuItem>
                }               
                <MenuItem icon={<img src={Dashboard} alt='Dashboard' />} onClick={() => handleMenuItemClick('/dashboard', 'Dashboard', 'Dashboard')}>Dashboard</MenuItem>
                {hasAccess.hospitalMasters && <SubMenu
                    open={open === 'Hospital Masters'}
                    onClick={() => handleSubmenuClick('Hospital Masters')}
                    icon={<img src={HospitalMaster} alt='HospitalMaster' />} label="Hospital Masters">
                    {hospitalMasters.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Hospital Masters')}>{data.label}</MenuItem>)}
                </SubMenu>}
                {hasAccess.maintenance && <SubMenu
                    open={open === 'Maintenance'}
                    onClick={() => handleSubmenuClick('Maintenance')}
                    icon={<img src={Maintenance} />} label="Maintenance" >
                    {maintenance.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Maintenance')}>{data.label}</MenuItem>)}
                </SubMenu>}
                {hasAccess.assets && <SubMenu
                    open={open === 'Assets'}
                    onClick={() => handleSubmenuClick('Assets')}
                    icon={<img src={Assets} />} label="Assets">
                    {assets.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Assets')}>{data.label}</MenuItem>)}
                </SubMenu>}
                {hasAccess.staff && <SubMenu
                    open={open === 'Staff'}
                    onClick={() => handleSubmenuClick('Staff')}
                    icon={<img src={Staff} alt='Staff' />} label="Staff">
                    {staff.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Staff')}>{data.label}</MenuItem>)}
                </SubMenu>}
                {hasAccess.inventory && <SubMenu
                    open={open === 'Inventory'}
                    onClick={() => handleSubmenuClick('Inventory')}
                    icon={<img src={InventoryStock} alt='Inventory' />} label="Inventory">
                    {inventory.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Inventory')}>{data.label}</MenuItem>)}
                </SubMenu>}
                {hasAccess.vendor && <SubMenu
                    open={open === 'Vendor'}
                    onClick={() => handleSubmenuClick('Vendor')}
                    icon={<img src={Vendor} alt='Vendor' />} label="Vendor">
                    {vendor.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Vendor')}>{data.label}</MenuItem>)}
                </SubMenu>}
                {hasAccess.contract && <SubMenu
                    open={open === 'Contract'}
                    onClick={() => handleSubmenuClick('Contract')}
                    icon={<img src={Contract} alt='Contract' />} label="Contract">
                    {contract.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Contract')}>{data.label}</MenuItem>)}
                </SubMenu>}
                {hasAccess.report && <SubMenu
                    open={open === 'Report'}
                    onClick={() => handleSubmenuClick('Report')}
                    icon={<img src={Report} alt='Report' />} label="Report"
                >
                    {hasAccess.reports.workOrder && <SubMenu
                        open={open2 === 'Work Order'}
                        onClick={() => handleSubmenu2Click('Work Order')}
                        label="Work Order">
                        {reports.workOrder.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Report')}>{data.label}</MenuItem>)}
                    </SubMenu>}
                    {hasAccess.reports.asset && <SubMenu
                        open={open2 === 'Asset'}
                        onClick={() => handleSubmenu2Click('Asset')}
                        label='Asset'>
                        {reports.asset.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Report')}>{data.label}</MenuItem>)}
                    </SubMenu>}
                    {hasAccess.reports.staff && <SubMenu
                        open={open2 === 'Staff'}
                        onClick={() => handleSubmenu2Click('Staff')}
                        label='Staff'>
                        {reports.staff.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Report')}>{data.label}</MenuItem>)}
                    </SubMenu>}
                    {hasAccess.reports.others && <SubMenu
                        open={open2 === 'Others'}
                        onClick={() => handleSubmenu2Click('Others')}
                        label='Others'>
                        {reports.others.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Report')}>{data.label}</MenuItem>)}
                    </SubMenu>}
                </SubMenu>}
                {hasAccess.calendar && <SubMenu open={open === 'Calender'}
                    onClick={() => handleSubmenuClick('Calender')}
                    icon={<img src={Calender} alt='Calender' />} label="Calendar">
                    {calendar.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Calender')}>{data.label}</MenuItem>)}
                </SubMenu>}
                {hasAccess.options && <SubMenu open={open === 'Options'}
                    onClick={() => handleSubmenuClick('Options')}
                    icon={<img src={Option} alt='Options' />} label="Options">
                    {options.filter(item => screenAccess[item.code]).map((data) => <MenuItem key={data.label} active={selectedIndex === data.label} onClick={() => handleMenuItemClick(data.path, data.label, 'Options')}>{data.label}</MenuItem>)}
                </SubMenu>}
            </Menu>
        </Sidebar >
    )
}

export default SideBar;
